import { AnimatedVideo } from '@/components/AniamtedVideo';
import { AnimatedText } from '@/components/AnimatedText';
import './styles.scss';

export const PresentationSection = () => {
  return (
    <div className='presentation-wrapper'>
      <div className='container presentation-container'>
        <div className='particles-wrapper'>
          <div className='particles'>
            <img
              className='particle particle-1'
              src='particles/1.webp'
              alt='Particles'
            />
            <img
              className='particle particle-2'
              src='particles/2.webp'
              alt='Particles'
            />
            <img
              className='particle particle-3'
              src='particles/3.webp'
              alt='Particles'
            />
          </div>
        </div>

        <section
          className='presentation-section presentation-section-0'
          key='0'
        >
          <AnimatedVideo src='promo.mp4' className='video' />
        </section>

        <section
          className='presentation-section presentation-section-1'
          key='1'
        >
          <AnimatedText
            className='row row-1'
            text='While OOH shouts at people'
            delay={0}
          />
          <AnimatedText className='row row-2' text='PlayWall' delay={200} />
          <AnimatedText
            className='row row-3'
            text='talks to them.'
            delay={400}
          />
        </section>

        <section
          className='presentation-section presentation-section-2'
          key='2'
        >
          <AnimatedText
            className='row row-1'
            text='We make crowds stop, play, share'
            delay={0}
          />
          <AnimatedText
            className='row row-2'
            text='- and we measure every second of it :'
            delay={200}
          />
          <AnimatedText className='row row-3' text='Attention.' delay={400} />
          <AnimatedText className='row row-4' text='Engagement.' delay={500} />
          <AnimatedText className='row row-5' text='Leads.' delay={600} />
          <AnimatedText className='row row-6' text='Proof.' delay={800} />
        </section>

        <section
          className='presentation-section presentation-section-3'
          key='3'
        >
          <AnimatedText
            className='row row-1'
            text='Stop renting eyeballs.'
            delay={0}
          />
          <AnimatedText
            className='row row-2'
            text='Start owning moments.'
            delay={200}
          />
        </section>

        <section
          className='presentation-section presentation-section-4'
          key='4'
        >
          <AnimatedText className='row row-1' text="We're" delay={0} />
          <AnimatedText className='row row-2' text='PlayWall - ' delay={200} />
          <AnimatedText
            className='row row-3'
            text={`and we're about to make on${String.fromCharCode(8209)}ground marketing`}
            delay={400}
          />
          <AnimatedText className='row row-4' text='the hottest' delay={600} />
          <AnimatedText className='row row-5' text='KPI machine' delay={800} />
          <AnimatedText className='row row-6' text='in town.' delay={1000} />
        </section>
      </div>
    </div>
  );
};
